export default {
    _ostrich_sansheavy: 'ostrich_sansheavy',
}